// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3tmqd","col":"CardReaderDesc_col__2UbzO","label":"CardReaderDesc_label__XEcax"};